var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscriptionFeeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_588_30642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7773 22.1035C10.7773 15.4761 16.1499 10.1035 22.7773 10.1035H33.7773C40.4048 10.1035 45.7773 15.4761 45.7773 22.1035V45.1035H22.7773C16.1499 45.1035 10.7773 39.7309 10.7773 33.1035V22.1035Z",
    fill: "url(#paint0_linear_588_30642)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0398 28.166V35.2632C36.0398 35.5321 35.9384 35.79 35.7579 35.9802C35.5774 36.1703 35.3326 36.2771 35.0773 36.2771H21.6023C21.3471 36.2771 21.1023 36.1703 20.9218 35.9802C20.7412 35.79 20.6398 35.5321 20.6398 35.2632V28.166H36.0398ZM30.7461 17.0132C31.3146 17.013 31.8739 17.1644 32.3719 17.4532C32.8699 17.742 33.2905 18.1589 33.5943 18.665C33.8982 19.1711 34.0756 19.75 34.1099 20.3478C34.1442 20.9455 34.0343 21.5427 33.7905 22.0837L37.0023 22.0827C37.2576 22.0827 37.5024 22.1895 37.6829 22.3796C37.8634 22.5698 37.9648 22.8277 37.9648 23.0966V26.1382C37.9648 26.4071 37.8634 26.665 37.6829 26.8552C37.5024 27.0453 37.2576 27.1521 37.0023 27.1521H19.6773C19.4221 27.1521 19.1773 27.0453 18.9968 26.8552C18.8162 26.665 18.7148 26.4071 18.7148 26.1382V23.0966C18.7148 22.8277 18.8162 22.5698 18.9968 22.3796C19.1773 22.1895 19.4221 22.0827 19.6773 22.0827L22.8892 22.0837C22.5463 21.325 22.4702 20.4627 22.6743 19.6504C22.8784 18.838 23.3496 18.1284 24.0039 17.6477C24.6582 17.167 25.4532 16.9465 26.2474 17.0255C27.0416 17.1044 27.7834 17.4777 28.3408 18.0788C28.6537 17.7407 29.0277 17.4722 29.4409 17.2892C29.8541 17.1061 30.2979 17.0123 30.7461 17.0132ZM25.9336 19.041C25.5628 19.0412 25.2063 19.1917 24.938 19.4612C24.6697 19.7307 24.51 20.0986 24.4922 20.4888C24.4744 20.8789 24.5998 21.2613 24.8423 21.5567C25.0848 21.8521 25.426 22.0379 25.795 22.0756L25.9336 22.0827H27.3773V20.5618C27.3773 20.1838 27.2436 19.8193 27.0023 19.5394C26.761 19.2596 26.4294 19.0844 26.0722 19.0481L25.9336 19.041ZM30.7461 19.041L30.6075 19.0481C30.2739 19.0818 29.9618 19.2367 29.7247 19.4862C29.4876 19.7358 29.3403 20.0644 29.3081 20.4158L29.3023 20.5618V22.0827H30.7461L30.8847 22.0756C31.2418 22.0391 31.5732 21.8639 31.8144 21.584C32.0555 21.3042 32.1891 20.9398 32.1891 20.5618C32.1891 20.1839 32.0555 19.8195 31.8144 19.5397C31.5732 19.2598 31.2418 19.0846 30.8847 19.0481L30.7461 19.041Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1773 32.1526C26.3033 32.1526 26.425 32.1941 26.5203 32.2694C26.6157 32.3448 26.6783 32.4491 26.6967 32.5633L26.7023 32.6339V34.2355C26.7025 34.357 26.6524 34.4742 26.5622 34.5633C26.4719 34.6524 26.3482 34.7069 26.2159 34.7159C26.0837 34.7248 25.9526 34.6875 25.8491 34.6115C25.7455 34.5355 25.6773 34.4263 25.6579 34.306L25.6523 34.2355V32.6339C25.6523 32.5062 25.7077 32.3838 25.8061 32.2936C25.9046 32.2033 26.0381 32.1526 26.1773 32.1526ZM28.2773 30.8693C28.4033 30.8693 28.525 30.9107 28.6203 30.9861C28.7157 31.0615 28.7783 31.1658 28.7967 31.2799L28.8023 31.3505V34.2355C28.8025 34.357 28.7524 34.4742 28.6622 34.5633C28.5719 34.6524 28.4482 34.7069 28.3159 34.7159C28.1837 34.7248 28.0526 34.6875 27.9491 34.6115C27.8455 34.5355 27.7773 34.4263 27.7579 34.306L27.7523 34.2355V31.3505C27.7523 31.2229 27.8077 31.1005 27.9061 31.0102C28.0046 30.92 28.1381 30.8693 28.2773 30.8693ZM30.3773 29.5859C30.5033 29.5859 30.625 29.6274 30.7203 29.7028C30.8157 29.7782 30.8783 29.8824 30.8967 29.9966L30.9023 30.0672V34.238C30.9025 34.3596 30.8524 34.4767 30.7622 34.5659C30.6719 34.655 30.5482 34.7095 30.4159 34.7185C30.2837 34.7274 30.1526 34.6901 30.0491 34.6141C29.9455 34.538 29.8773 34.4289 29.8579 34.3086L29.8523 34.238V30.0672C29.8523 29.9396 29.9077 29.8171 30.0061 29.7269C30.1046 29.6366 30.2381 29.5859 30.3773 29.5859Z",
    fill: "url(#paint1_linear_588_30642)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_588_30642",
    x: 0.777344,
    y: 0.103516,
    width: 55,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.429333 0 0 0 0 0.108333 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_588_30642"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_588_30642",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_588_30642",
    x1: 31.1791,
    y1: 44.7551,
    x2: 30.8368,
    y2: 8.81395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_588_30642",
    x1: 25.6523,
    y1: 32.1528,
    x2: 30.9023,
    y2: 32.1528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionFeeIcon);
export default __webpack_public_path__ + "static/media/subscription-fee-icon.80cdc0c28684cc0e5cf011c9fec5f5ae.svg";
export { ForwardRef as ReactComponent };